import { FORM_VALIDATOR_TYPES } from '../constants';
import { IAcademicYearForm, ITermForm } from '../interface/academicYear.interface';

export enum ACADEMIC_YEAR_STATUS_OPTIONS {
  UPCOMING = 'UPCOMING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  COMPLETED = 'COMPLETED',
}

export enum RE_ENROLLMENT_CYCLE_STATUS {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED',
}

/**
 * Raw status values only — labels are resolved at render time against the
 * `status.*` catalog via useTranslatedOptions(). Using the enum member as the
 * label is what put "ACTIVE"/"INACTIVE" in front of the user.
 */
export const ACADEMIC_YEAR_STATUS_VALUES = [
  ACADEMIC_YEAR_STATUS_OPTIONS.ACTIVE,
  ACADEMIC_YEAR_STATUS_OPTIONS.INACTIVE,
  ACADEMIC_YEAR_STATUS_OPTIONS.COMPLETED,
  ACADEMIC_YEAR_STATUS_OPTIONS.UPCOMING,
] as const;

export const ACADEMIC_YEAR_FORM_INIT: IAcademicYearForm = {
  name: {
    value: '',
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  curriculum: {
    value: null,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  startDate: {
    value: null,
    isRequired: false,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: true,
  },
  endDate: {
    value: null,
    isRequired: false,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: true,
  },
  status: {
    value: ACADEMIC_YEAR_STATUS_OPTIONS.UPCOMING,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
};

export const TERM_INIT: ITermForm = {
  id: {
    value: null,
    isRequired: false,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  name: {
    value: '',
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  startDate: {
    value: null,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: false,
  },
  endDate: {
    value: null,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: false,
  },
};
